<router-outlet></router-outlet>
<ngx-guided-tour progressIndicatorLocation="none"></ngx-guided-tour>
